import React, {useState} from 'react'
import ClinicOverview from "./ClinicOverview";
import AddressCard from './AddressCard';
import TimeZoneCard from './TimeZoneCard';
import LogoCard from './LogoCard';
import AssetsCard from './AssetsCard';

const InfoTab = () => {
    const [clinicLogo, setClinicLogo] = useState()

    const updateLogo = (logourl) => {
        console.log(logourl)
        setClinicLogo(logourl)
    }
    return (
        <>


            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-7 col-sm-7 d-flex flex-column">
                        <ClinicOverview updateLogo={updateLogo}/>

                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5">
                        <div className='d-flex flex-column'>
                            <LogoCard logoUrl={clinicLogo}/>
                            <AddressCard/>
                            <TimeZoneCard/>
                            <AssetsCard/>
                        </div>

                    </div>
                </div>
            </div>


        </>
    );
}

export default InfoTab;